import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';
import { showAction as showImageAction } from '../../../_flux/actions/image_light_box_actions';
import { getColor } from '../../../../lib/utilities';

function ImageLightBoxContent(props) {
    const {
        data,
        onClose
    } = props;

    let allThumbnails = document.querySelectorAll('.description__thumbnails:not(.lightbox-content-images) .thumb-3 img');

    if (allThumbnails) {
        allThumbnails = Array(...allThumbnails);
    }

    const onImageClick = (e, url, fromDots) => {
        let event = e.currentTarget;

        if (fromDots) {
            const childNumber = Array.prototype.indexOf.call(e.target.parentNode.children, e.target);
            const scrollElement = document.querySelector(`.description__thumbnails.lightbox-content-images > div:nth-child(${childNumber + 1})`);
            event = scrollElement;
        }

        
        const logo = $('.product-brand-logo').html();
        const title = `<div>
        <div>${logo}</div>
        <div>${$('.product__headline').text()}</div>
        </div>`;
        
        showImageAction({ url, title });
        setTimeout(() => {
            event.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }, 250);
    };

    return (
        <div className="image-light-box__content image-light-box-content">
            <img
                style={{ maxWidth: '100%' }}
                src={data.url}
                alt="Image not available"
            />

            <div className="description__thumbnails lightbox-content-images">
                {allThumbnails.map((thumbnail, key) => (<>
                    <div className="thumb-3" key={(thumbnail.src || thumbnail.dataset['original']) + key}>
                        <img
                            className="img-responsive lazy"
                            itemProp="image"
                            src={(thumbnail.src || thumbnail.dataset['original'])}
                            alt={thumbnail.alt}
                            onClick={(e) => onImageClick(e, (thumbnail.src || thumbnail.dataset['original']))}
                            style={{ maxWidth: '100%' }}
                        />
                    </div>
                </>))}
            </div>


            <div>
                {allThumbnails.map((thumbnail, key) => (<>
                    <div
                        key={(thumbnail.src || thumbnail.dataset['original']) + key}
                        className='thumbnail-dots'
                        style={{ backgroundColor: ((thumbnail.src || thumbnail.dataset['original']) === data.url) ? getColor('mainColor') : 'rgba(0, 0, 0, 0.6)' }}
                        onClick={(e) => onImageClick(e, (thumbnail.src || thumbnail.dataset['original']), true)}
                    ></div>
                </>))}
            </div>

            {props.error && props.error.invalid && <p
                name="error-cross-sell"
                className="image-light-box-content__why-alignment floating-label-element__hint--invalid"
                style={{ border: 'none' }}
                dangerouslySetInnerHTML={toDangerousReactHtml(props.error.invalidMessage)}
            />
            }
        </div>
    );
}

ImageLightBoxContent.propTypes = {
    expanded: PropTypes.bool.isRequired,
    LightBoxVisible: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onExpand: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { ImageLightBoxContent };
